import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40512807"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "tours-overview-location-picker",
  role: "dialog",
  "aria-labelledby": "map-location-picker-title",
  tabindex: "-1",
  "aria-hidden": "true",
  class: "modal fade"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "location-picker" }
const _hoisted_5 = { class: "location-picker__header" }
const _hoisted_6 = {
  id: "map-location-picker-title",
  class: "location-picker__title"
}
const _hoisted_7 = { class: "location-picker__actions" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "location-picker__map-content"
}
const _hoisted_10 = { class: "marker-content" }
const _hoisted_11 = { class: "marker-name" }
const _hoisted_12 = ["alt"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "img-block" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "content" }
const _hoisted_18 = {
  key: 0,
  class: "content-title"
}
const _hoisted_19 = { class: "list-unstyled d-flex list" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex item"
}
const _hoisted_21 = ["alt"]
const _hoisted_22 = {
  key: 1,
  class: "d-flex item"
}
const _hoisted_23 = ["alt"]
const _hoisted_24 = { key: 0 }

import { computed, ref } from 'vue'
import { GoogleMap, CustomMarker, MarkerCluster } from 'vue3-google-map'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import { useFilterPageStore } from '@/stores/filterPageStore'
import { TourPreviewDto } from '@/models/FilterPageTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToursOverviewMap',
  props: {
    tours: null
  },
  emits: ['handleModalClose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { tours: TourPreviewDto[] };




const mapId = ref('361976e16d9326d2') // map style (black and white)
const zoom = ref(10)
const selectedTour = ref<TourPreviewDto | undefined>()
const isSelectedTourShowing = ref(false)

const filterPageStore = useFilterPageStore()

const correctTours = computed(() => props.tours.filter((i) => i.Title && i.Coordinates?.length === 2))
const mapCenter = computed(() => correctTours.value[0]?.Coordinates ?? [0, 0])
const toursOverviewMap = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.ToursOverviewMapTitle') ?? '')
const timeUnits = computed(() => filterPageStore.getLocalization('FilterPage.ToursCollection.TimeUnits') ?? '')
const altMapMarker = computed(() => filterPageStore.getLocalization('Accessability.Images.MapMarker'))
const altLocation = computed(() => filterPageStore.getLocalization('Accessability.Images.Location'))
const altTime = computed(() => filterPageStore.getLocalization('Accessability.Images.Time'))
const modalClose = computed(() => filterPageStore.getLocalization('Accessability.Modal.Close'))
const gmapKey = computed(() => filterPageStore.googleMapKey)

const culture = computed(() => document.documentElement.dataset.culture?.toString() ?? '')


const onMarkerClick = (e: MouseEvent, tour: TourPreviewDto) => {
    isSelectedTourShowing.value = selectedTour.value?.KeyId === tour.KeyId ? !isSelectedTourShowing.value : true
    selectedTour.value = tour
}
const onModalClose = () => {
    emits('handleModalClose')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(toursOverviewMap)), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_Transition, { name: "tw-fade-top" }),
              _createElementVNode("button", {
                class: "location-picker__close",
                "aria-label": _unref(modalClose),
                "data-bs-dismiss": "modal"
              }, [
                _createVNode(CloseIcon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onModalClose()))
                })
              ], 8, _hoisted_8)
            ])
          ]),
          (_unref(gmapKey))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_unref(GoogleMap), {
                  "fullscreen-control": false,
                  "street-view-control": false,
                  "map-type-control": false,
                  "map-id": mapId.value,
                  "api-key": _unref(gmapKey),
                  language: _unref(culture),
                  class: "location-picker__map",
                  center: { lat: _unref(mapCenter)[0], lng: _unref(mapCenter)[1] },
                  zoom: zoom.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MarkerCluster), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(correctTours), (tour) => {
                          return (_openBlock(), _createBlock(_unref(CustomMarker), {
                            key: tour.KeyId,
                            options: { position: { lat: tour.Coordinates[0], lng: tour.Coordinates[1] } },
                            tabindex: "0",
                            "aria-label": tour.Title,
                            onKeyup: _withKeys(($event: any) => (onMarkerClick($event, tour)), ["enter"]),
                            onClick: ($event: any) => (onMarkerClick($event, tour)),
                            class: "custom-marker"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(tour.Title), 1),
                                _createElementVNode("img", {
                                  src: "/images/map-marker-yellow.svg",
                                  alt: _unref(altMapMarker)
                                }, null, 8, _hoisted_12)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["options", "aria-label", "onKeyup", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["map-id", "api-key", "language", "center", "zoom"])
              ]))
            : _createCommentVNode("", true),
          (selectedTour.value && isSelectedTourShowing.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "tour-map-item",
                href: selectedTour.value.DetailsUrl
              }, [
                _createElementVNode("div", _hoisted_14, [
                  (selectedTour.value.PreviewDesktop.Url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "d-none d-lg-block img-fluid",
                        src: selectedTour.value.PreviewDesktop.Url,
                        alt: selectedTour.value.PreviewDesktop.Alt
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (selectedTour.value.PreviewMobile.Url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "d-block d-lg-none img-fluid",
                        src: selectedTour.value.PreviewMobile.Url,
                        alt: selectedTour.value.PreviewMobile.Alt
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (selectedTour.value.Title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(selectedTour.value.Title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", _hoisted_19, [
                      (selectedTour.value.Location)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              src: "/images/ico-location-red.svg",
                              alt: _unref(altLocation)
                            }, null, 8, _hoisted_21),
                            _createElementVNode("p", null, _toDisplayString(selectedTour.value.Location), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (selectedTour.value.Duration)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              src: "/images/ico-time-red.svg",
                              alt: _unref(altTime)
                            }, null, 8, _hoisted_23),
                            _createElementVNode("p", null, _toDisplayString(selectedTour.value.Duration) + " " + _toDisplayString(_unref(timeUnits)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (selectedTour.value.MainTag)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(selectedTour.value.MainTag), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})